import { useRMSelector } from 'redux/hooks';
import { RootState } from 'redux/configureStore';

const useIngredientsSelectedRows = () => {
  const ingredientsSelectedRows = useRMSelector(
    (state: RootState) => state.ingredientsTable.selectedRows,
  );
  return ingredientsSelectedRows;
};

export default useIngredientsSelectedRows;
